import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Grid, Typography, Box, Card, CardContent, Link, Alert } from '@mui/material'
import axios from 'axios';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import { backend } from '../../statics/system_variables'



export default function StateHeader(props) {
    //This is the Header of the State Page
    //It includes Title, description, image and shelters
    //Rerenders when location is changed

    const location = useLocation().pathname;


    const [shelters, setShelters] = useState(['']);
    const [loading, setLoading] = useState(true);
    const [apiQuery, setApiQuery] = useState('')



    useEffect(() => {
        //alert('query')
        setLoading(true)
        if (apiQuery !== '') {
            axios.get(apiQuery).then(({ data }) => {
                setShelters(data)
                setLoading(false)
            }).catch((error) => {

            })
        }

    }, [apiQuery])



    useEffect(() => {
        //alert('location')
        const state = decodeURI(location.split('/')[2])
        var api_link = backend + '/shelters_by_state?&state=' + state

        setApiQuery(api_link)

    }, [location])



    const state = decodeURI(location.split('/')[2])
    const dogs = props.dogs


    return (
        <Box justifyContent='center' display='flex' >
            <Grid container spacing={5} marginBottom={3}>

                <Grid item xs={0} xl={3} />
                <Grid item xs={12} md={3}>
    
                    <Typography variant='h1'>
                        {state}
                    </Typography>

                    {/**Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
                    <br/>*/}
                    Laut dem <Link href='https://www.tierschutzbund.de/organisation/ueber-uns/tierheime/' target='_blank' rel='norefferer' title='zum deutschen Tierschutzbund'>Deutschen Tierschutzbund</Link> befinden sich folgende Tierheime in {state}:
                </Grid>
                <Grid item xs={0} xl={4} />
                <noInxed/>

                <Grid item xs={0} xl={3}/>
                {loading ? '' :
                    <Grid item xs={12} xl={6} >
                            <ShelterSlider shelters={shelters} state={state} />
                    </Grid>
                }
                <noInxedEnd/>
                <Grid item xl={3} />

                <Grid item xs={0} xl={3} />
                <Grid item xs={12} xl={6} >
                {dogs && <Alert variant='outlined' severity={dogs[2] > 0 ? 'success' : 'error'} sx={{ textAlign: 'center', justifyContent: 'center' }} component='h2'>
                            {dogs[2] > 0 ? dogs[2] + ' Hunde aus Tierheimen in ' + state + ' gefunden' : 'Diese Suche lieferte keine Resultate. Vielleicht solltest du die Filter ändern.'}
                        </Alert>}
                </Grid>
                <Grid item xl={3} />



            </Grid>


        </Box>


    )
}


function ShelterSlider(props) {

    const shelters = props.shelters

    const ENTRYS_PER_ROW = 3

    const settings = {
        className: "slider variable-width",
        dots: true,
        infinite: false,
        slidesToShow: ENTRYS_PER_ROW,
        slidesToScroll: ENTRYS_PER_ROW,
        centerPadding: '50px',
        variableWidth: false,
        rows: shelters.length > ENTRYS_PER_ROW ? 2 : 1,
        touchTreshold: 1,
        lazyLoad: 'progressive',
        swipeToSlide: true,
        centerMode: false
    };


    return <Box >
        <Slider {...settings}>
            {shelters.map((shelter) => (
                <React.Fragment key={shelter.homepage} >
                    <Box pr={2} pb={2}>
                        <ShelterCard homepage={shelter.homepage} name={shelter.name} adresse={shelter.adresse} />
                    </Box>
                </React.Fragment>
            ))}
        </Slider>
    </Box>
}


function ShelterCard(props) {

    //Freizugebene Informationen:


    //Name des Tierheimes
    //Website
    //Stadt
    //Foto des Tierheims


    //Name Inhaber
    //Mail Inhaber

    //Anzahl Hunde

    return (
        <Card >

            {/**<CardActionArea>
                <CardMedia
                    component="img"
                    height="100"
                    image={Mensch}
                    alt="Paella dish"
                />
    </CardActionArea>*/}

            <CardContent>

                <Link sx={{ fontSize: 14 }} href={props.homepage} color='inherit' underline='hover' target='_blank' rel='norefferer'  title={'zur Seite von ' + props.name}>
                    <Typography sx={{ fontSize: 15 }} variant="h6" component="div" noWrap={true}>
                        {props.name}
                    </Typography>
                </Link>

                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom mb={-1}>
                    {props.adresse.replace(/.*\d{5} ?/, '')}
                </Typography>

            </CardContent>




        </Card>
    )

}